import { Component, OnInit } from '@angular/core';


@Component({
  selector: 'app-mrf-employee-list',
  templateUrl: './mrf-employee-list.component.html',
  styleUrls: ['./mrf-employee-list.component.scss']
})
export class MrfEmployeeListComponent implements OnInit {
  countries = COUNTRIES;
  constructor() { }

  ngOnInit(): void {
  }

}




interface Country {
  
  row1:string;
  row2:string;
  row3:string;
  row4:string;
  row5:string;
  row6:string;
  row7:string;
  row8:string;
  row9:string;
  row10:string;
  row11:string;
  row12:string;
  row13:string;
  row14:string;
  row15:string;
  row16:string;
  row17:string;

}

const COUNTRIES: Country[] = [
  {
    row1:'kkkkkk',
    row2:'yyy',
    row3:'pppp',
    row4:'uuu',
    row5:'eeee',
    row6:'rrrr',
    row7:'tttt',
    row8:'eeeew',
    row9:'ffff',
    row10:'kkkkk',
    row11:'cccc',
    row12:'gggg',
    row13:'rrrr',
    row14:'kkkkk',
    row15:'xxxx',
    row16:'llll',
    row17:'oooo'
  }
 
];